module.exports = __webpack_public_path__ + "img/zlzx3.4558b506.png";